import { ContractStatus } from "../types/enums";

export function getContractStatusLabel(status: ContractStatus | string): string {
  const statusLabels: Record<string, string> = {
    [ContractStatus.MissingParts]: "Pièces manquantes",
    [ContractStatus.ToSend]: "À envoyer",
    [ContractStatus.Completed]: "Complété",
    [ContractStatus.Pending]: "En cours",
    [ContractStatus.DocToSend]: "Document à envoyer",
    [ContractStatus.ToComplete]: "À compléter",
    [ContractStatus.WAITING_SIGNATURE]: "En attente de signature",
    [ContractStatus.AENVOYER]: "À envoyer",
    [ContractStatus.TO_SIGN]: "À signer",
    [ContractStatus.ENVOYER]: "Envoyé",
    [ContractStatus.SIGNED]: "Signé",
  };

  return statusLabels[status] ?? "Complété";
}
